import { ContentBanner } from '@modernhealth/vital-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { BackButton } from '../components/BackButton';
import { Page } from '../components/PageLayout';
import { CirclesUpcomingTopicsByLanguage } from '../components/CirclesUpcomingTopicsByLanguage';

import {
    CirclesOnDemandByLanguageSection,
    useTranslatedHeader,
} from './CirclesOnDemandOverviewPage';

interface LanguagePageParams {
    languageCode: string;
}
export const CirclesOnDemandLanguagePage = () => {
    const { t } = useTranslation('circles');

    const { languageCode } = useParams<LanguagePageParams>();
    const header = useTranslatedHeader(languageCode);
    const description = `${t('pages.on_demand_by_language.header')} ${header.toLowerCase()}`;
    return (
        <Page.Container>
            <Page.Header>
                <BackButton />
            </Page.Header>

            <Page.Content
                css={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 32,
                }}
            >
                <ContentBanner
                    title={header}
                    description={description}
                    theme="dark"
                    css={{
                        border: 'none',
                        background: 'linear-gradient(180deg, #DAF5FD 0%, #FFFFFF 100%)',
                    }}
                />
                <CirclesOnDemandByLanguageSection
                    heading={t('sections.on_demand.header')}
                    key={languageCode}
                    languageCode={languageCode}
                />
                <CirclesUpcomingTopicsByLanguage languageCode={languageCode} />
            </Page.Content>
        </Page.Container>
    );
};
